import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import SubscribeFormUser from './SubscribeFormUser';
import { subscribe } from '../webAPI/MKSService';

class SubscribeFormUserContainer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			fields: {
				customerCode: '',
				postalCode: '',
				civility: '',
				firstName: '',
				lastName: '',
				function: '',
				email: '',
				password: '',
				termsOfSales: false
			}
		};

		this.handleTextFieldChange = this.handleTextFieldChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	render() {
		const { fields } = this.state;
		return (
			<SubscribeFormUser
				fields={fields}
				onTextFieldChange={this.handleTextFieldChange}
				onSubmit={this.handleSubmit}
			/>
		);
	}

	handleTextFieldChange(value, name) {
		const { fields } = this.state;
		this.setState({
			...this.state,
			fields: {
				...fields,
				[name]: value
			}
		});
	}

	handleSubmit() {
		const { fields } = this.state;

		const params = {
			postal_code: fields.postalCode,
			civility: fields.civility || 'mme',
			firstname: fields.firstName,
			lastname: fields.lastName,
			function: fields.function || 'secretaire',
			email: fields.email,
			password: fields.password
		};

		subscribe(params).then(error => null, result => null);

		browserHistory.push('/app/project-v2');
	}
}

export default SubscribeFormUserContainer;



// WEBPACK FOOTER //
// ./src/js/subscribe/SubscribeFormUserContainer.js